var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.0003,
    cy: 8.77865,
    r: 3.33333,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6663 18.4487C17.2731 17.2674 16.4066 16.2236 15.2013 15.4791C13.9959 14.7346 12.519 14.3311 10.9997 14.3311C9.48035 14.3311 8.00347 14.7346 6.7981 15.4791C5.59273 16.2236 4.72624 17.2674 4.33301 18.4487",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCircleOutline);
export default __webpack_public_path__ + "static/media/account-circle-outline.733a1625cac310a9c92750efe859d1d2.svg";
export { ForwardRef as ReactComponent };